<template>
  <div id="app">
    <notifications group="taskstodo" />
    <vue-progress-bar></vue-progress-bar>
    <router-view />
    <digisac-chat />
  </div>
</template>

<style src="./shared/styles/style.scss" lang="scss"></style>

<script>

// <style src="@/vendor/styles/bootstrap.scss" lang="scss"></style>
// <style src="@/vendor/styles/appwork.scss" lang="scss"></style>
// <style src="@/vendor/styles/theme-paper.scss" lang="scss"></style>
// <style src="@/vendor/styles/colors.scss" lang="scss"></style>
// <style src="@/vendor/styles/uikit.scss" lang="scss"></style>
// <style src="@/vendor/libs/vue-notification/vue-notification.scss" lang="scss"></style>
// <style src="/static/vendor/fonts/fontawesome.css" lang="scss"></style>
// <style src="@/app/layout/style.scss" lang="scss"></style>
import DigisacChat from '@/app/chats/DigisacChat.vue'
export default {
  name: 'app',
  metaInfo: {
    title: 'Index',
    titleTemplate: '%s - TaskTodo'
  },
  updated () {
    // Remove loading state
    setTimeout(() => document.body.classList.remove('app-loading'), 1)
  },
  // beforeUpdate () {
  //   this.createTomTicketChat()
  // },
  components: {
    DigisacChat
  }
  // methods: {
  //
  // createTomTicketChat () {
  //   let el = document.getElementById('chatTomTicket')
  //   if (!el && this.$store.getters['auth/isAuthenticatedInternal']) {
  //     let ttChatLoaderS = document.createElement('script')
  //     document.tomticketChatLoaderScriptVersion = 2
  //     ttChatLoaderS.id = 'chatTomTicket'
  //     ttChatLoaderS.src = 'https://pilarsistemas.tomticket.com/scripts-chat/chat.min.js' +
  //         '?id=EP42292' +
  //         '&account=2706688P15082020100354' +
  //         '&autoOpen=0' +
  //         '&hideWhenOffline=0' +
  //         '&d=pilarsistemas' +
  //         '&ts=' + new Date().getTime() +
  //         '&ref=' + encodeURIComponent(document.URL)
  //     document.body.appendChild(ttChatLoaderS)
  //   } else if (el && !this.$store.getters['auth/isAuthenticatedInternal']) {
  //     el.remove()
  //     let elChatWidget = document.getElementById('comTomTicketChatWidget')
  //     elChatWidget.remove()
  //     let elChatContainer = document.getElementById('comTomTicketChatContainer')
  //     elChatContainer.remove()
  //   }
  // }
  // }
}
</script>
